import React from 'react';

export interface IRegistrationPageProps {}

const Registration = (_props: IRegistrationPageProps) => {
  if (typeof window !== 'undefined') {
    window.location.href = 'https://www.deutsche-bildung.de/aktuelle-info/';
  }
  return null;
};

export const getStaticProps = async (): Promise<IRegistrationPageProps> => {
  return {
    props: {},
  };
};

Registration.requireAuth = 'registration';

export default Registration;
